import { defineComponent as _defineComponent } from 'vue'
import Icon from '../Icon.vue';
import SelectedPaymentDisplay from './SelectedPaymentDisplay.vue';
import { computed } from 'vue';
import { getThumbnailFromCardType } from 'JS/utilities/payment';
import { ICheckoutPayment } from 'JS/types/Checkout';
import { icons } from 'JS/constants/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedPayment',
  props: {
    card: null,
    total: null,
    buttonTitle: { default: 'Change' },
    disabled: { type: Boolean }
  },
  emits: ["updateCard"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'updateCard', card: ICheckoutPayment, remove: boolean);
}), expose: any, slots: any, attrs: any }) {

const props = __props as { card: ICheckoutPayment, total?: number, buttonTitle: string, disabled?: boolean }





const chargeAmount = computed(() => '$' + props.total.toCurrency());

const isGiftCard = computed(() => props.card.cardType === 'GiftCard');

const cardTitle = computed(() => {
	if (props.card.isRewardsGiftCard) {
		return 'Rewards Gift Card';
	}

	if (isGiftCard.value) {
		return 'Gift Card';
	}

	return props.card.description;
});

const iconType = computed(() => cardTitle.value === 'Gift Card'
	? icons.giftcard
	: icons.blain_eagle
);

const isPayPal = computed(() => props.card.cardType === "PayPal");

const updateCardLabel = computed(() => buttonText.value + ' Payment Method');

const buttonText = computed(() =>
	// Override button text for any gift card payment method as 'Remove'
	isGiftCard.value
		? 'Remove'
		: props.buttonTitle
);

return { __sfc: true,props, emit, chargeAmount, isGiftCard, cardTitle, iconType, isPayPal, updateCardLabel, buttonText, Icon, SelectedPaymentDisplay, getThumbnailFromCardType }
}

})